import React, {useEffect, useState} from "react";
import Button from "@material-ui/core/Button";
import {useDispatch, useSelector} from "react-redux";
import {addTire, addTireQuantity, setSearchQuantity} from "../../core/redux/ActionCreator";
import {Link} from "react-router-dom";
import {QUANTITY_MAX} from "../../shared/constants";

function QuoteButton(props) {
    const {isMobile = false, isCompare = false, ...restProps} = props;
    const cart = useSelector(state => state.cartReducer.cart);
    const results = useSelector(state => state.searchResultReducer.results);
    const tireIndex = results.findIndex(t => t.gmPartNum === restProps.gmPartNum);
    const tire = results[tireIndex];
    const quantity = tire.quantity;

    const [disabled, setDisabled] = useState(false);

    const dispatch = useDispatch();

    const addTireToCart = () => {
        //add flag for dealer tire installation
        const cartItem = {...tire};
        console.log(tire);
        cartItem['installation'] = true;

        if (!cart.some(item => item.gmPartNum === tire.gmPartNum)) {
            dispatch(addTire(cartItem));
        } else {
            dispatch(addTireQuantity(cartItem));
        }
    };

    useEffect(() => {
        if (isCompare) {
            setDisabled(false);
            const cartIndex = cart.findIndex(t => t.gmPartNum === restProps.gmPartNum);
            if (cartIndex !== -1 && cart[cartIndex].quantity < QUANTITY_MAX) {
                dispatch(setSearchQuantity({gmPartNum: restProps.gmPartNum, quantity: 1}));
            }
        } else if (quantity === 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [quantity, isCompare, cart, dispatch, restProps.gmPartNum, results]);

    return (
        <>
            <Button className={'button stat-button-link'} disabled={disabled} data-dtm={tire.brand + ':' + tire.name}
                    onClick={addTireToCart} component={Link} to={'/cart'}>
                {(isMobile && isCompare) ? 'Add' : 'Add to Quote'}
            </Button>
        </>
    )
}

export default QuoteButton;
